import { render, staticRenderFns } from "./productivityStat.vue?vue&type=template&id=82a5969a&scoped=true"
import script from "./productivityStat.vue?vue&type=script&lang=js"
export * from "./productivityStat.vue?vue&type=script&lang=js"
import style0 from "./productivityStat.vue?vue&type=style&index=0&id=82a5969a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a5969a",
  null
  
)

export default component.exports